import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components'
import {classes} from '@bitstillery/common/lib/utils'
import {activated_filters, activated_sort, reset_filters_sort} from '@bitstillery/common/lib/filters'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {CollectionProxy} from '@bitstillery/common/lib/collection'
import type {Filter} from '@bitstillery/common/types'

interface CollectionFilterControlAttrs {
    className?: string
    collection: CollectionProxy
    /** Render text labels inside the buttons (e.g. the shop filter panel header); default icon-only. */
    labels?: boolean
}

export class CollectionFilterControl extends MithrilComponent<CollectionFilterControlAttrs> {
    view(vnode: m.Vnode<CollectionFilterControlAttrs>) {
        // Gated on there being filters to act on rather than on the collection being ready — these two
        // buttons act on the filters and the sort, both of which are configuration a page can hand over
        // before its rows are loaded (the shop does, for its server render).
        const {filters} = vnode.attrs.collection
        if (!Object.keys(filters).length) {
            return null
        }

        const all_collapsed = Object.values(filters).every((filter: Filter) => filter.collapsed)
        const filters_activated = activated_filters(vnode.attrs.collection)
        const sort_diff = activated_sort(vnode.attrs.collection.state.sort)
        const sort_activated = sort_diff.by || sort_diff.order

        const filters_sort_activated = filters_activated || sort_activated

        return (
            <div className={classes('c-collection-filter-control', vnode.attrs.className)}>
                <Button
                    disabled={
                        !filters_sort_activated ||
                        vnode.attrs.collection.state.bulk_mode ||
                        vnode.attrs.collection.state.inline_edit_mode
                    }
                    icon={all_collapsed ? 'filterCollapsed' : 'filterCollapse'}
                    onclick={() => {
                        for (const filter of Object.values(filters)) {
                            filter.collapsed = !all_collapsed
                        }
                    }}
                    tip={() => {
                        const tip_all_collapsed = Object.values(filters).every((filter: Filter) => filter.collapsed)
                        if (tip_all_collapsed) {
                            return $t('filters.expand_tip')
                        }
                        return $t('filters.collapse_tip')
                    }}
                    type='info'
                    variant='toggle'
                >
                    {vnode.attrs.labels ? (
                        <span className='c-button-text'>{all_collapsed ? $t('filters.expand') : $t('filters.collapse')}</span>
                    ) : null}
                </Button>
                <Button
                    active={filters_activated > 0}
                    disabled={
                        !filters_sort_activated ||
                        vnode.attrs.collection.state.bulk_mode ||
                        vnode.attrs.collection.state.inline_edit_mode
                    }
                    icon='content_save_off_outline'
                    onclick={() => {
                        void reset_filters_sort(vnode.attrs.collection)
                    }}
                    tip={() => {
                        const tip_filters_activated = activated_filters(vnode.attrs.collection)
                        const tip_sort_diff = activated_sort(vnode.attrs.collection.state.sort)
                        const tip_sort_activated = tip_sort_diff.by || tip_sort_diff.order
                        const tip_filters_sort_activated = tip_filters_activated || tip_sort_activated
                        if (tip_filters_sort_activated) {
                            return $t('filters.reset')
                        }
                        return $t('filters.reset_disabled')
                    }}
                    type={filters_sort_activated ? 'brand' : 'info'}
                    variant='toggle'
                >
                    {vnode.attrs.labels ? <span className='c-button-text'>{$t('filters.clear')}</span> : null}
                </Button>
            </div>
        )
    }
}
